import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { ExperienceList } from "../Data/ExperienceList";

type ExperienceProps = { isSmallScreen: boolean };

function Experience(props: ExperienceProps) {
  const theme = useTheme();

  return (
    <Box sx={{ py: 6 }}>
      <Typography variant="h1" fontWeight={700}>
        <span style={{ color: theme.palette.secondary.main }}>Experience</span>
      </Typography>
      {ExperienceList.map((exp) => (
        <Box
          key={exp.id}
          sx={{
            mb: 4,
            pl: 3,
            borderLeft: `2px solid ${theme.palette.secondary.main}`,
          }}
        >
          <Typography variant="h2" sx={{ py: 0, mb: 0 }}>
            {exp.role}
          </Typography>
          <Typography
            variant="body1"
            sx={{ color: theme.palette.secondary.main, mb: 1 }}
          >
            {exp.company} &middot; {exp.date}
          </Typography>
          <ul style={{ margin: 0, paddingLeft: "1.2rem" }}>
            {exp.bullets.map((bullet, i) => (
              <li key={i}>
                <Typography variant="body2">{bullet}</Typography>
              </li>
            ))}
          </ul>
        </Box>
      ))}
    </Box>
  );
}

export default Experience;
